// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"da2895d6","80":"44ec8d5f"}[chunkId] + ".chunk.js";
};